<div class="dialog-content-small">
      <label for="">Captcha</label>
        <div class="formgrid grid">
          
<div class="captcha">
    <h2>{{captcha}}</h2>
</div>  
    <i class="fa fa-refresh refreshcaptcha" aria-hidden="true" pTooltip="Refresh Captcha" (click)="refresh()"
       [ngClass]="{'rotate': isRotating}"
      tooltipPosition="bottom" ></i></div>

 

        <div class="formgrid grid"  >
            <div class="field col-12 lg:col-12 md:col-12 sm:col-12">
                 <input type="text" class="form-control" id="captchatext" placeholder="Enter Captcha Code" name="captchatext" [(ngModel)]="captchatext">
                 <span *ngIf="invalid" style="color: red;">{{invalidcaptchamsg}}</span>            

            </div>
        </div>

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose"
            (click)="onclose()"></p-button>

        <p-button class="m-1" label="Reset" styleClass="customesave" (click)="validate()">
        </p-button>
    </div>
</div>

<!-- captcha close -->



